export enum ActionMenuItem {
  ADD_NOTE = 'add-note',
  EDIT_NOTE = 'edit-note',
  MARK_COMPLETE = 'mark-complete',
  SEND_INVITE_REMINDER = 'send-invite-reminder',
  SEND_TEAM_REMINDER = 'send-team-reminder',
  ENTER_TEAM_INFO = 'enter-team-info',
  EDIT_TEAM_INFO = 'edit-team-info',
  LOADING = 'loading',
  INVITE_JUDGE = 'invite-judge',
  REMOVE_JUDGE = 'remove-judge',
  RESET_CHECKIN = 'reset-checkin',
  RESET_CHECKIN_GUEST = 'reset-checkin-guest',
  TRANSFER_SPONSORSHIP = 'transfer-sponsorship',
  VIEW_PURCHASE = 'view-purchase',
  DELETE_WINNER = 'delete-winner',
}

export enum ActionMenuLabel {
  ADD_NOTE = 'Add Note',
  RESET_CHECKIN = 'Reset Check-in',
  EDIT_NOTE = 'Edit Note',
  MARK_COMPLETE = 'Mark Complete',
  SEND_INVITE_REMINDER = 'Send Invite Reminder',
  SEND_TEAM_REMINDER = 'Send Team Reminder',
  ENTER_TEAM_INFO = 'Enter Team Info',
  LOADING = 'Loading',
  EDIT_TEAM_INFO = 'Edit Team Info',
  TRANSFER_SPONSORSHIP = 'Transfer Sponsorship',
}

export interface MenuOption {
  key: ActionMenuItem
  label: ActionMenuLabel | string
  disabled?: boolean
  icon?: string
  cb?: () => Promise<void>
}

export interface MenuOptionsProps {
  options: MenuOption[]
  rowId: string
  rowData?: any
  position?: 'top' | 'bottom'
  xShift?: number
  onSelect?: (key: ActionMenuItem, rowData: any) => void
}
